import { IAssignee, IAssigneeIdMap } from "../models";
import { searchAssignees } from "../utils";
import { IAssigneesStoreState } from "./assignee-reducer";

export function toTeamAssigneeIdMap(state: IAssigneesStoreState): IAssigneeIdMap {
  const teamMap: IAssigneeIdMap = {};
  for (const [id, assignee] of Object.entries(state.assignees.map)) {
    if (assignee.type === "team") {
      teamMap[id] = assignee;
    }
  }
  return teamMap;
}

export function toUserAssigneeIdMap(state: IAssigneesStoreState): IAssigneeIdMap {
  const userMap: IAssigneeIdMap = {};
  for (const [id, assignee] of Object.entries(state.assignees.map)) {
    if (assignee.type === "user") {
      userMap[id] = assignee;
    }
  }
  return userMap;
}

export function getFilteredAssigneesRedux(options: {
  assignees: IAssignee[];
  assigneeName?: string;
  limit: number;
  assigneeType: "user" | "team" | "both";
}): IAssignee[] {
  const shouldSkip = (assignee: IAssignee): boolean => {
    return assignee.isActive === false || (options.assigneeType !== "both" && assignee.type !== options.assigneeType);
  };

  return searchAssignees(options.assigneeName, options.assignees, { limit: options.limit, shouldSkip });
}
